<style lang="scss" scoped>
@import '../assets/css/style.scss';
  .title {
    width: 100%;
    height: 67px;
    // border-bottom: 1px solid #F0F0F0;
    // padding: 0 42px 0 33px;
    @include flex-between-and-vertical-center();
    .title-l {
      color: #333;
      font-weight: 500;
      line-height: 67px;
      padding-left: 8px;
      position: relative;

      &::before {
        content: '';
        display: block;

        width: 4px;
        height: 20px;

        position: absolute;
        left: 0;
        top: 50%;
        transform: translateY(-50%);
        background-color: #FC8D40;
      }
    }
  }
</style>

<template>
  <div class="title">
    <div class="title-l" :style="{fontSize: fontSize + 'px'}">{{name}}</div>
    <slot></slot>
  </div>
</template>
<script>
export default {
  props: {
    name: {
      type: String,
      default: ''
    },
    fontSize: {
      type: String, 
      default: '18'
    }
  },
  data() {
    return {

    }
  }
}
</script>




// WEBPACK FOOTER //
// src/components/title.vue